import { render, staticRenderFns } from "./productAuto.vue?vue&type=template&id=8d02795c&scoped=true"
import script from "./productAuto.vue?vue&type=script&lang=js"
export * from "./productAuto.vue?vue&type=script&lang=js"
import style0 from "./productAuto.vue?vue&type=style&index=0&id=8d02795c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d02795c",
  null
  
)

export default component.exports